module.exports = __webpack_public_path__ + "img/09.4e070349.gif";